import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import DashboardSectionCard from "./DashboardSectionCard";
import EmptyState from "./EmptyState";
import { API_BASE } from "@config/env";

const fmtDate = (d) => {
  if (!d) return "";
  try { return new Date(d).toLocaleDateString("en-US",{month:"short",day:"numeric"}); }
  catch { return d; }
};

const TYPE_BG    = ["","#16A34A","#F59E0B","#2563EB","#7C3AED"];
const TYPE_LABEL  = ["","Full-time","Part-time","Contract","Freelance"];
const getType = (t) => {
  const idx = parseInt(t);
  return {
    bg:    TYPE_BG[idx]    || "#6366F1",
    color: "#fff",
    label: TYPE_LABEL[idx] || String(t),
  };
};
const COLORS = ["#2563EB","#7C3AED","#16A34A","#D97706","#EF4444"];

export default function ActiveJobs({ userSlug }) {
  const [jobs,    setJobs]    = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (!userSlug) return;
    const fd = new FormData();
    fd.append("user_slug", userSlug);
    fd.append("search_text", "");
    fd.append("per_page", "5");
    axios.post(API_BASE+"get-latest-job-postings", fd)
      .then(res => {
        const list = res.data?.job_list || res.data?.data || [];
        setJobs(Array.isArray(list) ? list.slice(0,5) : []);
        setLoading(false);
      }).catch(() => setLoading(false));
  }, [userSlug]);

  return (
    <DashboardSectionCard title="Active Jobs" subtitle="Latest open positions" icon="fa-briefcase" colorKey="blue"
      action={jobs.length > 0
        ? <Link to="/jobs" style={{fontSize:12,fontWeight:600,color:"var(--fc-primary)",textDecoration:"none"}}>View all &rarr;</Link>
        : null}>

      {loading ? (
        <div style={{display:"flex",flexDirection:"column",gap:8}}>
          {[1,2,3].map(i => (
            <div key={i} style={{background:"var(--fc-bg-light)",borderRadius:10,padding:"12px 14px",display:"flex",gap:12,alignItems:"center"}}>
              <div style={{width:3,height:36,borderRadius:99,background:"var(--fc-border-strong)",flexShrink:0}} />
              <div style={{flex:1}}>
                <div style={{height:12,background:"var(--fc-border-light)",borderRadius:4,width:"55%",marginBottom:7}} />
                <div style={{height:10,background:"var(--fc-border-light)",borderRadius:4,width:"35%"}} />
              </div>
            </div>
          ))}
        </div>
      ) : jobs.length === 0 ? (
        <EmptyState icon="fa-briefcase" text="No active jobs" sub="Post your first job to see it here" actionLabel="Post a job" actionTo="/create-job" />
      ) : (
        <div style={{display:"flex",flexDirection:"column",gap:8}}>
          {jobs.map((job,i) => {
            const tc    = getType(job.job_type);
            const color = COLORS[i % COLORS.length];
            return (
              <div key={i}
                onClick={() => navigate("/job/details/"+job.job_slug)}
                style={{background:"var(--fc-bg-light)",border:"1px solid var(--fc-border-light)",borderRadius:10,padding:"11px 13px",cursor:"pointer",transition:"all 0.15s",display:"flex",alignItems:"center",gap:12}}
                onMouseEnter={e=>{e.currentTarget.style.background="var(--fc-primary-light)";e.currentTarget.style.borderColor="var(--fc-primary-border)";}}
                onMouseLeave={e=>{e.currentTarget.style.background="var(--fc-bg-light)";e.currentTarget.style.borderColor="var(--fc-border-light)";}}>

                {/* Accent bar */}
                <div style={{width:3,height:36,borderRadius:99,background:color,flexShrink:0}} />

                {/* Info */}
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontSize:13,fontWeight:600,color:"var(--fc-text-primary)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",marginBottom:5}}>
                    {job.job_title}
                  </div>
                  <div style={{display:"flex",alignItems:"center",gap:6,flexWrap:"wrap"}}>
                    <span style={{fontSize:10,fontWeight:700,padding:"2px 9px",borderRadius:99,background:tc.bg,color:tc.color,whiteSpace:"nowrap"}}>
                      {tc.label}
                    </span>
                    {(job.creator_name||job.employer_name) && (
                      <span style={{fontSize:11,fontWeight:600,color:"var(--fc-text-secondary)",display:"flex",alignItems:"center",gap:3,whiteSpace:"nowrap"}}>
                        <i className="fa-solid fa-user" style={{fontSize:8,color:"var(--fc-text-subtle)"}}/>
                        {job.creator_name||job.employer_name}
                      </span>
                    )}
                  </div>
                </div>

                {/* Date */}
                {job.created_on && (
                  <div style={{fontSize:11,fontWeight:600,color:"var(--fc-text-muted)",flexShrink:0,background:"var(--fc-border-light)",padding:"3px 8px",borderRadius:6}}>
                    {fmtDate(job.created_on)}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </DashboardSectionCard>
  );
}
